export const clickTracker = (target: HTMLElement) => {

    const buttonRole: HTMLAnchorElement & HTMLButtonElement = target.closest('a[role="button"], button[role="button"]');

    const sliderNav: HTMLButtonElement = target.closest(
        'button[aria-label="Prev card"], button[aria-label="Prev item"], button[aria-label="Next card"], button[aria-label="Next item"]');

    const share: HTMLElement = target.closest('[data-share]');

    const cardLink: HTMLAnchorElement = target.closest('reply-card-runtime a, .rose-cards-slider__item a, a.quicklink-card, a.wall-slider-with-title__item');

    const accordion: HTMLElement = target.closest('.accordion-item-header');

    const menuFirstLevel: HTMLElement = target.closest('.nav-item.first-level');
    const menuSecondLevel: HTMLElement = target.closest('li.second-level, li.third-level');

    const canvasSliderLink: HTMLElement = target.closest('.slide__content');

    const particlesLink: HTMLElement = target.closest('.particle__elementCircle');

    const cardsTabberTab: HTMLElement = target.closest('cards-tabber-runtime .tabs-nav .nav-item');

    if (accordion?.closest('.accordion-item') && !accordion?.closest('.accordion-item').hasAttribute('data-item-active')) {
        trackAccordion(accordion);

    } else if (particlesLink) {
        trackParticlesClick(particlesLink);
    } else if (canvasSliderLink) {
        trackCanvasClick(canvasSliderLink);
    } else if (share) {
        trackContentSharing(share);

    } else if (sliderNav) {
        trackSliderNav(sliderNav.closest('[data-items-count], [data-tabs-count], rose-banner-runtime'));

    } else if (menuFirstLevel) {
        trackMenuItem(menuFirstLevel.firstElementChild as HTMLElement, menuSecondLevel);

    } else if (buttonRole) {
        const hrefArray = buttonRole.href?.split('.');

        if (Array.isArray(hrefArray) && ['pdf', 'zip'].includes(hrefArray[hrefArray.length - 1])) {
            if (buttonRole.closest('.card-serp-default')) {
                trackSERPDownload(buttonRole);
            }
            if (buttonRole.hasAttribute('data-form-download')) {
                trackFormDownload(buttonRole);
            } else {
                trackDownload(buttonRole);
            }
        } else if (buttonRole.hasAttribute('data-form-download') && buttonRole.href?.includes('/crm/download-content/')) {
            trackFormDownload(buttonRole, true);
        } else if (buttonRole.closest('.card-serp-default')) {
            trackSERPDownload(buttonRole);
        } else {
            if (buttonRole.id === '4ARuq') {
                trackDownloadFullReport(buttonRole);
            } else {
                trackCTAClick(buttonRole);
            }
            
        }

    } else if (cardLink && !cardLink.closest('reply-card-runtime')?.classList.contains('card-serp-default')) {
        trackCardClick(cardLink);

    } else if (cardsTabberTab) {
        trackTabClick(cardsTabberTab)
    }
};

const trackMenuItem = (firstLevel: HTMLElement, secondLevel: HTMLElement) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'click_menu_item',
        eventCategory: 'menu_item_click',
        eventAction: firstLevel.textContent.trim(),
        eventLabel: secondLevel?.textContent?.trim() ?? 'not_present'
    });
};

const trackAccordion = (target: HTMLElement) => {
    const id = target.closest('.accordion-item, .expandable-content').id;
    const language = target.closest('[data-language]')?.getAttribute('data-language');

    let name: string;
    if (target.closest('.accordion-item')) {
        name = target.closest('.accordion-item').querySelector('.accordion-item-header').textContent.trim();
    } else {
        name = target.closest('.expandable-content').querySelector('h3, .ProseMirror *:first-child').textContent.trim();
    }

    if (id && language && name) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 
            event: 'click_open_accordion', 
            eventCategory: `accordion - ${name}`,
            eventAction: `click_accordion - ${id}`,
            eventLabel: `language_${language}`
        });
    }
};

const trackSliderNav = (target: HTMLElement) => {
    const cardsNumber = 
        target.dataset.itemsCount 
        || target.dataset.tabsCount 
        || target.querySelector('[data-slides-num]').getAttribute('data-slides-num');
    const id = target.id;

    if (cardsNumber && id) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'click_scroll_carousel',
            eventCategory: 'carousel_scroll',
            eventAction: `card_number - ${cardsNumber}`,
            eventLabel: `id_carousel - ${id}`
        });
    }
};

const trackCTAClick = (target: HTMLElement) => {
    const id = target.id;
    const language = target.closest('[data-language]')?.getAttribute('data-language');
    const name = target.textContent.trim() || 'null';

    if (id && language) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'click_cta',
            eventCategory: `cta - ${name}`,
            eventAction: `click_cta - ${id}`,
            eventLabel: `language_${language}`
        });
    }
};

const trackDownloadFullReport = (target: HTMLElement) => {
    const id = target.id;
    const language = target.closest('[data-language]')?.getAttribute('data-language');
    const name = target.textContent.trim() || 'null';

    if (id && language) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'download_full_report',
            eventCategory: `cta - ${name}`,
            eventAction: `click_cta - ${id}`,
            eventLabel: `language_${language}`,
            page_location: window.location.href,
            destination_url: target.getAttribute('data-hyperlink-title')
        });
    }
};

const trackDownload = (target: HTMLElement) => {
    const language = target.closest('[data-language]')?.getAttribute('data-language');
    const title = (target.getAttribute('data-hyperlink-title') || target.title || 'null').trim();

    if (language) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'download_file',
            eventCategory: 'file_download',
            eventAction: 'click_to_download_file',
            eventLabel: `language_${language}`,
            file_name: title,
            page_location: window.location.href
        });
    }
};

const trackContentSharing = (target: HTMLElement) => {
    const social = target.getAttribute('data-share');
    const title = document.querySelector('title')?.textContent.trim();

    if (social && title) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'content_sharing',
            eventCategory: `content - ${title}`,
            eventAction: 'click_to_share_content',
            eventLabel: `social_network - ${social}`
        });
    }
};

const trackCardClick = (target: HTMLAnchorElement) => {
    const wholeCard = target.closest('[id]');
    const id = wholeCard.id;
    const language = target.closest('[data-language]').getAttribute('data-language');
    const isRose = target.closest('.rose-cards-slider__item');
    const name = wholeCard.querySelector('header, h3, h4, .ProseMirror').textContent.trim();

    if (id && language && name) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'click_card',
            eventCategory: `card - ${name}`,
            eventAction: isRose ? `click_card - [ROSE] ${id}` : `click_card - ${id}`,
            eventLabel: `language_${language}`,
            destination_url: target.href || "not_present"
        }); 
    }
};

export const trackCardHover = (target: HTMLElement) => {
    const id = target.id;
    const language = target.closest('[data-language]').getAttribute('data-language');
    const name = target.querySelector('h3').textContent.trim();

    if (id && language && name) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'hover_card',
            eventCategory: `card - ${name}`,
            eventAction: `hover_card - ${id}`,
            eventLabel: `language_${language}`,
            destination_url: "not_present"
        });
    }
}

const trackFormDownload = (target: HTMLElement, overrideTitle: boolean = false) => {
    const language = target.getAttribute('data-language');
    let title = target.getAttribute('data-hyperlink-title').trim() || 'null';
    if (overrideTitle) {
        title = document.querySelector('h2').textContent.trim() || 'null';
    }

    if (language && title) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'form_submit',
            eventCategory: 'form_download',
            eventAction: 'click_to_download_file',
            eventLabel: `language_${language}`,
            title: title
        });
    }
};

const trackSERPDownload = (target: HTMLElement) => {
    const language = target.closest('[data-language]').getAttribute('data-language');
    const title = (target.getAttribute('data-hyperlink-title') || target.title || 'null').trim();

    if (language && title) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'internal_search',
            eventCategory: 'site_search',
            eventAction: 'click_download_research',
            eventLabel: `language_${language}` ,
            resultTitle: title || 'null'
        });
    }
};

const trackCanvasClick = (target: HTMLElement) => {
    const canvasTitle = target.closest('heroslider-runtime').querySelector('.slider__title h1').textContent.trim();
    let linkTitle = target.querySelector('.h6--medium')?.textContent?.trim();
    if (!linkTitle) {
        linkTitle = target.querySelector('.ProseMirror')?.textContent?.trim();
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'main_carousel_click',
        eventCategory: `main carousel - ${canvasTitle}`,
        eventAction: window.location.pathname,
        eventLabel: linkTitle || '' ,
    });
};

const trackParticlesClick = (target: HTMLElement) => {
    const linkTitle = target.closest('.particles-item').querySelector('.particle__elmentText').textContent.trim();
    const linkHref = target.closest('.particle__elementCircle').getAttribute('href');

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'particle_item_button_click',
        eventCategory: linkTitle || 'null',
        eventAction: linkHref || 'null',
        eventLabel: window.location.pathname,
    });

};

const trackTabClick = (target: HTMLElement) => {
    const id = target.id;
    const language = target.closest('[data-language]').getAttribute('data-language');
    const name = target.querySelector('.ProseMirror').textContent.trim();

    if (id && language && name) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'click_tab',
            eventCategory: `tab - ${name}`,
            eventAction: `click_tab - ${id}`,
            eventLabel: `language_${language}`
        });
    }
}

export const trackPath = () => {
    const levels = window.location.pathname.split('/');
    const params = window.location.search;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'page_path_level',
        full_url: window.location.href.replace(/https?:\/\//i, ''),
        path_l1: `/${levels[1]}`,
        path_l2: levels[2] ? `/${levels[2]}` : 'null',
        path_l3: levels[3] ? `/${levels[3]}` : 'null',
        path_l4: levels[4] ? `/${levels[4]}` : 'null',
        querystring_par: params || 'null',
    });
};

// for those things with a behavior already set on click
addEventListener('mousedown', (e) => {
    const accordion: HTMLElement = (<HTMLElement>e.target).closest('#expandable-content__toggle');

    if (accordion?.ariaExpanded === 'false') {
        trackAccordion(accordion);
    }
})